'use client'

import styles from './styles/kula.module.css'

export const EmbeddedIframe = () => (
  <iframe className={styles.acko} title="acko-careers" id="kula_embed" src="https://careers.kula.ai/acko?jobs=true" />
)
